/* @flow weak */
import CircleSpinner from 'components/CircleSpinner';
import Coin from 'components/Coin';
import Glyph from 'components/Glyph';
import * as React from 'react';

import './styles/ReadReceipt.scss';

type Props = {
  labelDisplay?: boolean,
  glyphDisplay?: boolean,
  iconSize?: 'xxxsmall' | 'xxsmall' | 'xsmall' | 'small',
  status: string,
  errorCount?: number,
};

class ReadReceipt extends React.Component<Props> {
  static defaultProps = {
    iconSize: 'xxxsmall',
  };

  renderDelivered = () => {
    return (
      <span>
        {this.props.labelDisplay && <span>Delivered</span>}
        {this.props.glyphDisplay && (
          <Coin className="ReadReceipt-icon" color="atlas" size={this.props.iconSize}>
            <Glyph color="whiteout" name="check" solo />
          </Coin>
        )}
      </span>
    );
  };

  renderDeliveryError = () => {
    return (
      <span>
        {this.props.labelDisplay && (
          <span>
            {this.props.errorCount && this.props.errorCount + ' '}
            {this.props.errorCount && this.props.errorCount > 1
              ? 'Delivery errors'
              : 'Delivery error'}
          </span>
        )}
        {this.props.glyphDisplay && (
          <Coin className="ReadReceipt-icon" border="apple" size={this.props.iconSize}>
            <Glyph color="apple" name="explanation" solo />
          </Coin>
        )}
      </span>
    );
  };

  renderPendingInitialAck = () => {
    return (
      <span>
        {this.props.labelDisplay && <span>Sending</span>}
        {this.props.glyphDisplay && (
          <CircleSpinner className="ReadReceipt-icon" color="atlas" size="small" />
        )}
      </span>
    );
  };

  renderRead = () => {
    return (
      <span>
        {this.props.labelDisplay && <span>Read</span>}
        {this.props.glyphDisplay && (
          <Coin className="ReadReceipt-icon" color="mascot" size={this.props.iconSize}>
            <Glyph color="whiteout" name="check" solo />
          </Coin>
        )}
      </span>
    );
  };

  renderSent = () => {
    return (
      <span>
        {this.props.labelDisplay && <span>Sent</span>}
        {this.props.glyphDisplay && (
          <Coin className="ReadReceipt-icon" border="atlas" size={this.props.iconSize}>
            <Glyph color="atlas" name="check" solo />
          </Coin>
        )}
      </span>
    );
  };

  render() {
    const presenter = {
      sent: this.renderSent,
      read: this.renderRead,
      delivered: this.renderDelivered,
      delivery_error: this.renderDeliveryError,
      pending_initial_ack: this.renderPendingInitialAck,
      unreachable: () => null,
    }[this.props.status];

    return presenter && <span className="ReadReceipt">{presenter()}</span>;
  }
}

export default ReadReceipt;
